// extracted by mini-css-extract-plugin
export default {"whichAirports":"WhichAirport_whichAirports__ayAq9","whichAirportsArrival":"WhichAirport_whichAirportsArrival__tZ0Kt","nextButton":"WhichAirport_nextButton__TKh19"};